import { memo } from 'react';

import { Divider } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import Typography from '@mui/material/Typography';
import { useInterviewOptions } from '@providers/InterviewsProvider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InterviewListItem from './InterviewListItem';

const ArchivedInterviewsAccordion = () => {
    const { archivedInterviews, selectInterview } = useInterviewOptions();

    if (!archivedInterviews?.length) {
        return null;
    }

    return (
        <Accordion
            sx={{
                backgroundColor: 'transparent',
                boxShadow: 'none',
                '&:before': { display: 'none' }, // Remove default divider
                mt: 1,
            }}
            disableGutters
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: 'text.secondary' }} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{
                    minHeight: 40,
                    px: 2,
                    '& .MuiAccordionSummary-content': { my: 0.5 },
                }}
            >
                <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                    Archived Surveys ({archivedInterviews.length})
                </Typography>
            </AccordionSummary>
            <Divider sx={{ mx: 2 }} />
            <AccordionDetails sx={{ p: 0, pb: 2 }}>
                {archivedInterviews.map((interview) => (
                    <InterviewListItem
                        key={interview.id + interview.groupId}
                        interview={interview}
                        handleSelection={({ id, groupId }) => selectInterview(id, groupId)}
                    />
                ))}
            </AccordionDetails>
        </Accordion>
    );
};

export default memo(ArchivedInterviewsAccordion);
